import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { routes } from '@libs/utils';
import { PushTagOnClickDirective, TagEvent } from '@libs/shared-services';
import { MarkdownPipe } from 'ngx-markdown';
import { SiteSetupNavbarComponent } from '../../site-setup/components/site-setup-navbar/site-setup-navbar.component';
import { SiteSetupComponentService, StepNumberEnum } from '../../site-setup/site-setup.component.service';

@Component({
  selector: 'lib-server-installation-download',
  imports: [CommonModule, SiteSetupNavbarComponent, TranslateModule, PushTagOnClickDirective, MarkdownPipe],
  templateUrl: './server-installation-download.component.html',
  styleUrl: './server-installation-download.component.scss',
})
export class ServerInstallationDownloadComponent {
  private readonly service = inject(SiteSetupComponentService);
  public vm = this.service.viewModel;

  public routes = routes;
  public StepNumberEnum = StepNumberEnum;
  public TagEvent = TagEvent;
}
